module.exports = __webpack_public_path__ + "img/logo.8d034580.png";